import { useEffect, useRef } from 'react'
import { useParams } from 'react-router-dom'
import useDirectory from 'hooks/useDirectory'
import { useRecoilState, useRecoilValue } from 'recoil'
import {
  buildingModeState,
  SelectedMode,
  selectedPoint
} from 'store/buildingStore'
import { currentAnnotation } from 'store/krpanoStore'
import currentViewerState from 'store/viewerStore'
import { AnnotationType } from 'types/building'

import { AnnotationElbowHandler } from '../handlers/AnnotationElbowHandler'

export function useAnnotationElbowCreation(
  krpanoElementId: string = 'embedpano-viewer'
) {
  const { id, floorId } = useParams()
  const { getBuiildingType, isRN } = useDirectory()
  const [buildingMode, setBuildingMode] = useRecoilState(buildingModeState)
  const [currentViewer] = useRecoilState(currentViewerState)
  const currentSelectedPoint = useRecoilValue(selectedPoint)
  const [currentSelected, setCurrentSelected] =
    useRecoilState(currentAnnotation)

  const handlerRef = useRef(new AnnotationElbowHandler())

  useEffect(() => {
    const krpanoPreview = document.getElementById(krpanoElementId) as any

    if (!krpanoPreview || (!isRN && getBuiildingType() !== 30)) return
    ;(window as any).get_mouse_position = () => {
      if (
        buildingMode.selectedMode === SelectedMode.RN_COMMENT_ANNOTATION &&
        (isRN || getBuiildingType() === 30)
      ) {
        const h = krpanoPreview.get('mouseath')
        const v = krpanoPreview.get('mouseatv')

        const result = handlerRef.current.addClickPosition(
          h,
          v,
          krpanoPreview,
          AnnotationType.COMMENT
        )

        if (result) {
          setCurrentSelected({
            building_id: +(id || 0),
            floor_id: +(currentViewer.selectedFloor || floorId || 0),
            point_id: currentViewer.selectedPoint || currentSelectedPoint || '',
            files: [],
            ...result
          } as any)
        }
      }
    }
  }, [
    buildingMode.selectedMode,
    currentSelectedPoint,
    currentViewer.selectedFloor,
    currentViewer.selectedPoint,
    floorId,
    getBuiildingType,
    id,
    isRN,
    krpanoElementId,
    setBuildingMode,
    setCurrentSelected
  ])

  useEffect(() => {
    if (
      (buildingMode.selectedMode !== SelectedMode.RN_COMMENT_ANNOTATION ||
        !currentSelected) &&
      handlerRef.current.count > 0
    ) {
      const krpano = document.getElementById(krpanoElementId) as any
      if (krpano) {
        handlerRef.current.reset(krpano)
      }
    }
  }, [buildingMode.selectedMode, currentSelected, krpanoElementId])
}

export default useAnnotationElbowCreation
